import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { HttpParams } from "@angular/common/http";
import { CarrierRepository } from "../../../carrier/carrier.repository";
import { Carrier } from "../../../carrier/carrier.model";
import { Bind } from "primeng/bind";
import { MultiSelect } from "primeng/multiselect";
import { FormsModule } from "@angular/forms";

export interface CarrierChangeEvent {
  originalEvent: MouseEvent;
  value: Carrier[];
}

@Component({
  selector: "app-carrier-multiselect",
  styleUrls: ["./carrier-multiselect.component.scss"],
  templateUrl: "./carrier-multiselect.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, MultiSelect, FormsModule],
})
export class CarrierMultiselectComponent implements OnInit, OnChanges {
  private carrierRepository = inject(CarrierRepository);

  public readonly carrierChange = output<Carrier[]>();
  @Input() public carriers: Carrier[];
  public readonly kind = input<string[]>(undefined);
  public readonly disabled = input(false);
  public readonly required = input(false);
  public readonly originCountry = input<string>(undefined);
  public readonly destinationCountry = input<string>(undefined);
  public readonly discriminator = input<string>(undefined);
  public readonly maxSelectedLabels = input<number>(1);

  public subscription = new Subscription();
  public carrierList: SelectItem[] = [];
  public loaded = false;

  ngOnInit() {
    this.buildCarrierList();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.originCountry &&
        !changes.originCountry.firstChange &&
        changes.originCountry.currentValue !==
          changes.originCountry.previousValue) ||
      (changes.destinationCountry &&
        !changes.destinationCountry.firstChange &&
        changes.destinationCountry.currentValue !==
          changes.destinationCountry.previousValue)
    ) {
      this.carriers = [];
      this.onCarrierChange(this.carriers);
      this.buildCarrierList();
    }
  }

  public onCarrierChange(event: Carrier[]) {
    this.carrierChange.emit(event);
  }

  private buildCarrierList(): void {
    this.loaded = false;
    this.carrierList = [];
    let params = new HttpParams();
    const kind = this.kind();
    if (kind) {
      const filteredKind = kind.filter(function (el) {
        return el != null;
      });
      if (!!filteredKind && filteredKind.length) {
        params = params.append("criteria[kind]", filteredKind.join(","));
      }
    }

    const discriminator = this.discriminator();
    if (discriminator) {
      params = params.append("criteria[discriminator]", discriminator);
    }

    const originCountry = this.originCountry();
    if (originCountry) {
      params = params.append("criteria[originCountry]", originCountry);
    }

    const destinationCountry = this.destinationCountry();
    if (destinationCountry) {
      params = params.append(
        "criteria[destinationCountry]",
        destinationCountry,
      );
    }

    this.carrierRepository.list(params).subscribe((carrierList) => {
      carrierList.forEach((carrier) => {
        this.carrierList.push({ label: carrier.getName(), value: carrier });
      });
      this.loaded = true;
    });
  }
}
